<div class="app-loader">
    <app-progress-bar-loader></app-progress-bar-loader>
</div>
<nav *ngIf="!isWhiteboardDevice" class="navbar fixed-top navbar-expand navbar-light bg-light">
    <div class="icon-container" (click)="onMenuClicked()">
        <a *ngIf="showIcon" class="navbar-brand cursor" data-cy-button="hamburger">
            <mat-icon svgIcon="{{icon}}"></mat-icon>
        </a>
    </div>
    <div class="collapse navbar-collapse">
        <span class="navbar-text">
            {{heading}}
        </span>
        <span class="navbar-text">
            <span class="badge badge-pill badge-primary">{{stockLocation}}
                {{physicalLocationTheatreRoomName}}
                <span *ngIf="deviceService.isTheaterDevice()"> - {{ deviceType }}</span>
            </span>
        </span>
        <span [ngClass]="{'ml-auto':  theatreTimer}" *ngIf="theatreTimer">
            <span [ngClass]="{'ml-auto':  recoveryTimer}" *ngIf="recoveryTimer" class="t5 bold displayed-recovery-time">
                <div class="circle-container">
                    <div class="recovery-circle">
                        <div class="circle-text">R</div>
                    </div>
                </div>
                {{ recoveryTimer * 1000 | date:'HH':'UTC' }} : {{ recoveryTimer * 1000 | date:'mm':'UTC' }} : {{
                recoveryTimer
                * 1000 | date:'ss':'UTC' }}
            </span>

            <span class="t5 bold displayed-time">
                <div class="circle-container">
                    <div class="operating-room-circle">
                        <div class="operating-room-circle">
                            <div class="circle-text">OR</div>
                        </div>
                    </div>
                </div>
                {{ theatreTimer * 1000 | date:'HH':'UTC' }} :
                {{ theatreTimer * 1000 | date:'mm':'UTC' }} : {{ theatreTimer
                * 1000 | date:'ss':'UTC' }}
            </span>
        </span>

        <div class="horizontal-spacer"></div>

        <div class="mr-2" [ngClass]="{'ml-auto': !theatreTimer}">
            <div class="header-icons-container">
                <div>
                    <span class="navbar-text text-capitalize">
                        <div class="mt-2 d-none d-sm-block"> Hi {{username}} </div>
                    </span>
                    <span class="navbar-text" *ngIf="showInitials">
                        <div class="circle">
                            {{initials}}
                        </div>
                    </span>
                </div>
                <div class="message-icon-container">
                    <mat-icon class="messagePointer topPaddMessaging" svgIcon="messageNone" [hidden]="!messaging"
                        (click)="onMessageClicked()"></mat-icon>
                    <span class="message-badge" *ngIf="newMessage">{{messageCount }}</span>
                </div>
                <div class="wifi-icon-container">
                    <mat-icon svgIcon="wifi-on" [hidden]="!isConnected"></mat-icon>
                    <mat-icon svgIcon="wifi-off" [hidden]="isConnected"></mat-icon>
                </div>
            </div>
        </div>

    </div>
</nav>

<mat-drawer-container>
    <mat-drawer [(opened)]="opened" class="bg-color">
        <div class="ml-auto d-flex user-info">
            <span class="sidebar-text">
                <div class="circle">
                    {{initials}}
                </div>
            </span>
            <span class="sidebar-text text-capitalize">
                <div class="mt-2 d-none d-sm-block"> {{username}} </div>
            </span>
        </div>

        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="bg-color menu">
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding (click)="navigate(node)" class="menu-item">
                <mat-icon class="side-bar-icon" [svgIcon]="node.icon"></mat-icon>
                <div class="horizontal-spacer"></div>
                {{node.display}}
            </mat-tree-node>

            <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding matTreeNodeToggle
                class="menu-item">
                <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name" class="mat-e">
                    <mat-icon [svgIcon]="treeControl.isExpanded(node) ? 'expand-more' : 'chevron-right'"></mat-icon>
                </button>
                <div class="horizontal-spacer"></div>
                {{node.display}}
            </mat-tree-node>

        </mat-tree>

    </mat-drawer>
    <mat-drawer-content>
        <div class="app-container">
            <div class="app-container-holder" [ngClass]="{'no-background': hideBackground }">
                <router-outlet></router-outlet>
            </div>
        </div>
    </mat-drawer-content>
</mat-drawer-container>